import AccountConfirmation from './containers/AccountConfirmationContainer'

export default {
  path: '/account-confirmation/:uuid',
  component: AccountConfirmation
}



// WEBPACK FOOTER //
// ./src/routes/accountConfirmation/index.js